import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import api from '@utils/api';
import { useI18n } from '@/i18n';
import PageHeader from '@components/PageHeader';
import { IconChevron } from '@components/icons';

export default function Faq() {
  const { t } = useI18n();
  const [q,       setQ]       = useState('');
  const [faqs,    setFaqs]    = useState([]);
  const [loading, setLoading] = useState(true);
  const [openId,  setOpenId]  = useState(null);

  const load = (query) => {
    setLoading(true);
    api.get('/faqs', { params: query ? { q: query } : {} })
      .then(({ data }) => setFaqs(data.faqs))
      .catch(() => {})
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(''); }, []);

  const submit = (e) => { e.preventDefault(); load(q); };

  return (
    <>
      <PageHeader title={t('faq.title')} subtitle={t('faq.subtitle')} />
      <div className="px-5 md:px-0 pb-6">
        <form onSubmit={submit} className="mb-4 flex gap-2">
          <input className="input flex-1" value={q} placeholder={t('faq.searchPlaceholder')} onChange={(e) => setQ(e.target.value)} />
          <button type="submit" className="btn-primary">{t('faq.search')}</button>
        </form>

        {loading ? (
          <div className="card p-8 text-center text-gray-400">{t('common.loading')}</div>
        ) : faqs.length === 0 ? (
          <div className="card p-8 text-center text-gray-500 text-sm">{t('faq.empty')}</div>
        ) : (
          <ul className="space-y-2">
            {faqs.map((f) => (
              <li key={f.id} className="card overflow-hidden">
                <button onClick={() => setOpenId(openId === f.id ? null : f.id)}
                  className="w-full text-left px-5 py-4 flex items-center gap-3 cursor-pointer">
                  <span className="flex-1 text-sm font-medium text-glk-dark">{f.question}</span>
                  <IconChevron size={18} className={`text-gray-300 shrink-0 transition-transform ${openId === f.id ? 'rotate-90' : ''}`} />
                </button>
                {openId === f.id && (
                  <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }}
                    className="px-5 pb-5 border-t border-gray-100">
                    <p className="text-sm text-glk-dark whitespace-pre-wrap mt-4">{f.answer}</p>
                  </motion.div>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </>
  );
}
